import {type FunctionalComponent, h} from '@stencil/core';


interface VoicePromoBannerProps {
  clickHandler: CallableFunction;
}


export const VoicePromoBanner:FunctionalComponent<VoicePromoBannerProps> = ({clickHandler}) => {
    return <div class="voice-promo-banner__container">
      <div class="voice-promo-banner__text-section">
        <h3 class="voice-promo-banner__title">
          Unlock quick and easy searching! Discover what you need with our new Beta Voice Search feature.
        </h3>
      </div>
      <qds-button class="voice-promo-banner__button" size="large" importance='standard' text={'Try it out'}
        onClick={clickHandler}
      ></qds-button>
    </div>;
};
